
export type StudioEnvironment =
    "None"
    | "Development"
    | "Testing"
    | "Production";